<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="6">
                <v-card>
                    <v-form ref="providerForm" v-model="isValid">
                        <v-card-text>
                            <v-container class="pb-0" fluid>
                                <v-row class="pb-0">
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Is Active"
                                            v-model="provider.isActive"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule]"
                                            label="Practice"
                                            v-model="provider.practiceName"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[
                                                requiredRule,
                                                lengthRule(13),
                                            ]"
                                            label="Practice Number"
                                            v-model="provider.practiceNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[
                                                requiredRule,
                                                lengthRule(13),
                                            ]"
                                            label="BHF Number"
                                            v-model="provider.bhfNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading"
                                            :items="disciplines"
                                            item-text="value"
                                            item-value="key"
                                            label="Primary Discipline"
                                            v-model="provider.primaryDiscipline"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-autocomplete
                                            :disabled="isLoading"
                                            :items="disciplines"
                                            chips
                                            deletable-chips
                                            item-text="value"
                                            item-value="key"
                                            label="More Disciplines"
                                            multiple
                                            v-model="provider.disciplines"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule]"
                                            label="Doctor"
                                            v-model="provider.doctorName"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[
                                                requiredRule /*,emailRule*/,
                                            ]"
                                            label="Email"
                                            v-model.trim="provider.emailAddress"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule]"
                                            autocomplete="tel"
                                            label="Cell"
                                            v-model="provider.cellNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-combobox
                                            :items="[]"
                                            deletable-chips
                                            hide-selected
                                            label="Add extra emails"
                                            multiple
                                            small-chips
                                            v-model="provider.providerEmails"
                                        >
                                            <template v-slot:no-data>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Press
                                                            <kbd>enter</kbd> to
                                                            add.
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-autocomplete
                                            :disabled="isLoading"
                                            :items="areas"
                                            :rules="[
                                                (v) =>
                                                    v.length > 0 ||
                                                    'atleast one area is required',
                                            ]"
                                            chips
                                            clearable
                                            deletable-chips
                                            item-text="value"
                                            item-value="key"
                                            label="Areas"
                                            multiple
                                            v-model="provider.areaIds"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-autocomplete
                                            :disabled="isLoading"
                                            :items="providerGroups"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Provider Group"
                                            v-model="provider.providerGroupId"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(50)]"
                                            label="Street"
                                            v-model="provider.addressLine1"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(50)]"
                                            label="City"
                                            v-model="provider.addressLine3"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Postal code"
                                            v-model="provider.addressPostalCode"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Admin Fee %"
                                            min="0"
                                            type="number"
                                            v-model.number="
                                                provider.adminFeePercentage
                                            "
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Prefund Fee %"
                                            min="0"
                                            type="number"
                                            v-model.number="
                                                provider.prefundFeePercentage
                                            "
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Is Vat Registered"
                                            v-model="provider.isVatRegistered"
                                        ></v-switch>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        v-show="provider.isVatRegistered"
                                    >
                                        <v-text-field
                                            :disabled="isLoading"
                                            label="Vat Number"
                                            v-model.number="provider.vatNumber"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Case Review Period"
                                            min="0"
                                            type="number"
                                            v-model.number="
                                                provider.caseReviewDays
                                            "
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Only Business Days"
                                            v-model="
                                                provider.caseReviewBusinessDaysOnly
                                            "
                                        ></v-switch>
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Payment Due Date"
                                            min="0"
                                            type="number"
                                            v-model.number="
                                                provider.paymentDueDays
                                            "
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Only Business Days"
                                            v-model="
                                                provider.paymentDueBusinessDaysOnly
                                            "
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Is an Accicare admittance facility."
                                            v-model="
                                                provider.isAccicareAdmittanceFacility
                                            "
                                        ></v-switch>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Bank Name"
                                            v-model="provider.bankName"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Account Name"
                                            v-model="provider.accountName"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Account No"
                                            v-model="provider.accountNo"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Branch Code"
                                            v-model="provider.branchCode"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[]"
                                            label="Branch Name"
                                            v-model="provider.branchName"
                                        ></v-text-field>
                                    </v-col>
                                    

                                    
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Supplier Direct Claim for RAF2"
                                            v-model="provider.useRaf2Defaults"
                                            :false-value="true"
                                            :true-value="false"
                                        ></v-switch>
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Use e-Raf defaults for RAF2 form"
                                            v-model="provider.useRaf2Defaults"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12">
                                    <v-expand-transition>
                                        <v-row
                                            v-show="!provider.useRaf2Defaults"
                                        >
                                            <v-col cols="12">
                                                <v-text-field
                                                    :disabled="isLoading"
                                                    label="Direct supplier contact email address"
                                                    v-model="
                                                        provider.raf21SupplierDetailsEmail
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    :disabled="isLoading"
                                                    label="Account number of direct supplier bank account"
                                                    v-model="
                                                        provider.raf23BankAccountSupplierRepresentativeAccountNumber
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    :disabled="isLoading"
                                                    label="Name of direct supplier bank"
                                                    v-model="
                                                        provider.raf23BankAccountBankRepresentativeName
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    :disabled="isLoading"
                                                    label="Branch code of direct supplier bank account"
                                                    v-model="
                                                        provider.raf23BankAccountBranchRepresentativeCode
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    :disabled="isLoading"
                                                    label="Name of direct supplier bank account holder"
                                                    v-model="
                                                        provider.raf23BankAccountNameOfRepresentativeAccountHolder
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    :disabled="isLoading"
                                                    label="Signed at"
                                                    v-model="
                                                        provider.raf211DeclarationSignedAt
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-file-input
                                                    :disabled="isLoading"
                                                    accept="image/png, image/jpeg, image/bmp"
                                                    label="Signature image"
                                                    placeholder="Set signature image"
                                                    v-model="signatureImage"
                                                >
                                                    <template
                                                        slot="append-outer"
                                                    >
                                                        <v-icon
                                                            color="light-green"
                                                            v-show="
                                                                provider.raf211SignatureFileId >
                                                                0
                                                            "
                                                            >mdi-check</v-icon
                                                        >
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        <!--
                                            <v-col cols="12">
                                                <v-file-input
                                                    :disabled="isLoading"
                                                    accept="image/png, image/jpeg, image/bmp"
                                                    label="Stamp image"
                                                    placeholder="Set stamp image"
                                                    v-model="stampImage"
                                                >
                                                    <template
                                                        slot="append-outer"
                                                    >
                                                        <v-icon
                                                            color="light-green"
                                                            v-show="
                                                                provider.raf211StampFileId >
                                                                0
                                                            "
                                                            >mdi-check</v-icon
                                                        >
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        -->
                                        </v-row>
                                    </v-expand-transition>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                                >
                                    <v-btn
                                        :disabled="isLoading && !isDeleting"
                                        :loading="isDeleting"
                                        @click="deleteEntity"
                                        class="text-none"
                                        color="warning darken-1"
                                        text
                                        v-show="provider.id > 0"
                                        >Delete</v-btn
                                    >
                                    <v-btn
                                        :disabled="isLoading"
                                        @click="closeForm"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                        >Close</v-btn
                                    >
                                    <v-btn
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >
                                        {{ provider.id > 0 ? "Update" : "Add" }}
                                    </v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar
                        :color="notifyColor"
                        :timeout="15000"
                        top
                        v-model="notifyShow"
                    >
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                @click="notifyShow = false"
                                class="text-none"
                                icon
                                v-bind="attrs"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" v-show="provider.id > 0">
                <h3>
                    Files
                    <v-btn
                        :disabled="isLoading"
                        @click="newProviderFile"
                        class="text-none ml-2"
                        color="secondary darken-1"
                        fab
                        x-small
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </h3>

                <v-card
                    :key="providerFile.id"
                    @click="loadProviderFileForm(providerFile)"
                    class="mt-5"
                    no-gutters
                    v-for="providerFile in provider.providerFiles"
                >
                    <v-card-text class="py-0">
                        <v-row>
                            <v-col cols="8">
                                {{
                                    providerFileTypes.find(
                                        (x) =>
                                            x.key ==
                                            providerFile.providerDocumentTypeId
                                    )
                                        ? providerFileTypes.find(
                                              (x) =>
                                                  x.key ==
                                                  providerFile.providerDocumentTypeId
                                          ).value
                                        : ""
                                }}
                                <br />
                                Valid Until:
                                {{ validUntilDisplay(providerFile.validUntil) }}
                                <br />
                                Verified:
                                {{ providerFile.isVerified ? "Yes" : "No" }}
                                <br />
                                Verification Updated By:
                                {{ providerFile.verfiedByUser }}
                            </v-col>

                            <v-col
                                align-self="center"
                                class="text-center"
                                cols="4"
                            >
                                <v-btn
                                    @click.stop="
                                        $store.dispatch('files/get', {
                                            fileId: providerFile.fileId,
                                            namePrefix:
                                                providerFile.providerId.toString() +
                                                '_' +
                                                providerFileTypes
                                                    .find(
                                                        (x) =>
                                                            x.key ==
                                                            providerFile.providerDocumentTypeId
                                                    )
                                                    .value.split(' ')
                                                    .join('_'),
                                        })
                                    "
                                    fab
                                >
                                    <h3>
                                        <v-icon color="light-blue"
                                            >mdi-download</v-icon
                                        >
                                    </h3>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-dialog
                persistent
                v-model="providerFileFormVisible"
                width="500px"
            >
                <ProviderFileForm
                    :key="providerFileFormKey"
                    :provider-file-in="providerFileFormEntity"
                    @close="closeProviderFileForm"
                    @deleted="deletedProviderFile"
                    @saved="savedProviderFile"
                />
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import Provider from "../../models/Provider.model";
import ProviderFile from "../../models/ProviderFile.model";
import ProviderFileForm from "../forms/ProviderFileForm";
import dateToString from "../../helpers/dateToString";
export default {
    props: {
        providerIn: Provider,
        disciplines: Array,
    },
    mounted: async function () {
        this.areas = await this.$store.dispatch("areas/getlist");
        this.providerGroups = await this.$store.dispatch(
            "providerGroups/getlist"
        );
        this.providerFileTypes = await this.$store.dispatch(
            "providers/getFileTypes"
        );
    },
    components: {
        ProviderFileForm,
        //
    },
    data() {
        return {
            provider: new Provider().set(this.providerIn),
            areas: [],
            providerGroups: [],
            providerFileTypes: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: (v) => /.+@.+$/.test(v) || "invalid email",

            providerFileFormKey: null,
            providerFileFormEntity: null,
            providerFileFormVisible: false,
            signatureImage: null,
            stampImage: null,
        };
    },

    methods: {
        validUntilDisplay(date) {
            var dateOut = dateToString(date ? new Date(date) : null);
            return dateOut ? dateOut : "Indefinitely";
        },
        //subform handlers--------------------
        savedProviderFile(providerFileIn) {
            var updateIndex = this.provider.providerFiles.findIndex(
                (x) => x.id == providerFileIn.id
            );
            if (updateIndex > -1)
                this.$set(
                    this.provider.providerFiles,
                    updateIndex,
                    providerFileIn
                );
            else this.provider.providerFiles.push(providerFileIn);
            this.emitSavedEntity(this.provider);
        },
        deletedProviderFile(providerFileIn) {
            var deletedIndex = this.provider.providerFiles.findIndex(
                (x) => x.id == providerFileIn.id
            );
            if (deletedIndex > -1)
                this.$delete(this.provider.providerFiles, deletedIndex);

            this.emitDeletedEntity(providerFileIn);
        },
        newProviderFile() {
            var providerFile = new ProviderFile();
            providerFile.id = 0;
            providerFile.providerId = this.provider.id;
            this.loadProviderFileForm(providerFile);
        },
        loadProviderFileForm(providerFile) {
            this.providerFileFormEntity = providerFile;
            this.providerFileFormKey = providerFile.id;
            this.providerFileFormVisible = true;
        },
        closeProviderFileForm() {
            this.providerFileFormKey = null;
            this.providerFileFormVisible = false;
        },

        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedProvider) {
            var newDiscipline = this.disciplines.find(
                (x) => x.id == savedProvider.disciplineId
            );
            if (newDiscipline)
                savedProvider.disciplineName = newDiscipline.name;
            this.$emit("saved", savedProvider);
        },
        emitDeletedEntity(deletedProvider) {
            this.$emit("deleted", deletedProvider);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.providerForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                if (!this.provider.adminFeePercentage)
                    this.provider.adminFeePercentage = 0;

                if (!this.provider.prefundFeePercentage)
                    this.provider.prefundFeePercentage = 0;

                this.provider.vatNumber = (
                    this.provider.vatNumber || ""
                ).toString();

                var formdata = new FormData();
                formdata.append("Signature", this.signatureImage);
                formdata.append("Stamp", this.stampImage);
                formdata.append("Model", JSON.stringify(this.provider));

                const parameters = {
                    id: this.provider.id,
                    formData: formdata,
                };
                var hasId = this.provider.id > 0;
                try {
                    var providerWithInfo = await this.$store.dispatch(
                        "providers/" + (hasId ? "update" : "create"),
                        hasId ? parameters : parameters.formData
                    );

                    this.notify("Provider successfully saved.", "success");
                    if (!(this.provider.id > 0))
                        this.provider.id = providerWithInfo.entity.id;

                    this.emitSavedEntity(providerWithInfo);
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this provider profile?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("providers/delete", this.provider.id)
                    .then(
                        () => {
                            this.notify(
                                "Provider successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.provider);
                            this.closeForm();
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>